import { HeaderRightComponent } from './HeaderRightComponent';

export const PageTitle = (props: {
    title: string | JSX.Element;
    showTypeSelect?: boolean;
    // showSearchButton?: boolean;
    disableSelect?: boolean;
    defalultData?: number | null;
}) => {
    return (
        <div
            className="page-title"
            style={{
                minHeight: 72,
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {props.showTypeSelect ? <HeaderRightComponent {...props} /> : props.title}
        </div>
    );
};
